<template>
  <div class="factorCode">
    <a-radio-group name="dataType" v-model="factorCode" :options="typeOptions" @change="factorCodeChange">
    </a-radio-group>
    <line-chart ref="chart1" chart="chart1" :style="{ width: width, height: height }"></line-chart>
  </div>
</template>

<script>
import lineChart from '@/components/bigDataChart/lineChart'
import {
  getAction
} from '@/api/manage'
import {
  querySiteTree,
  querySiteList
} from '@/api/api'
import {
  GetSiteIdMixin
} from '@/mixins/GetSiteIdMixin'
export default {
  name: 'waterLineChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw',
    },
    height: {
      type: String,
      default: '590px',
    },
    reportType: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    initNum: {
      type: Number,
      default: 0,
    },
  },
  components: {
    lineChart,
  },
  data() {
    return {
      url: '',
      typeOptions: [],
      factorCode: '',
      chartData: {},
      siteNameObj: {},
      ids: '',
      treeSt: '',
      typeOptionsSource: []
    }
  },
  created() {
    this.syncSiteNamesFromStorage()
    this.loadSiteNames()
    this._busSiteNamesHandler = (map) => {
      if (map && typeof map === 'object') {
        this.siteNameObj = Object.assign({}, this.siteNameObj, map)
        if (this.factorCode && this.dataObj && this.dataObj[this.factorCode]) {
          this.changeCode()
        }
      }
    }
    this.$bus.$on('siteNamesMap', this._busSiteNamesHandler)

    this.treeSt = window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType') || ''
    if (this.treeSt) {
      this.url = '/online/st' + this.treeSt + '/chart'
    }
    const currentSites = window.sessionStorage.getItem('sites') || ''
    if (currentSites) {
      const ids = this.getTreeCurrentIds()
      this.ids = ids[1] || ''
    }
    window.addEventListener('setItem', this.eventFunc)
  },
  beforeDestroy() {
    window.removeEventListener('setItem', this.eventFunc)
    if (this._busSiteNamesHandler) {
      this.$bus.$off('siteNamesMap', this._busSiteNamesHandler)
    }
  },
  methods: {
    eventFunc(e) {
      if (e.key == 'treeSt' || e.key == 'siteType') {
        const newSt = window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType') || ''
        if (newSt) {
          this.treeSt = newSt
          this.url = '/online/st' + newSt + '/chart'
          this.loadSiteNames()
          if (this.ids && this.startTime && this.endTime) {
            this.querySewageQuotaList(this.reportType, this.ids)
          }
        }
      }
    },
    syncSiteNamesFromStorage() {
      try {
        const raw = sessionStorage.getItem('siteNamesMap')
        if (raw) {
          const map = JSON.parse(raw)
          if (map && typeof map === 'object') {
            this.siteNameObj = Object.assign({}, this.siteNameObj, map)
          }
        }
      } catch (e) {}
    },
    /*站点列表*/
    loadSiteNames() {
      this.syncSiteNamesFromStorage()
      const targetSt = this.treeSt || window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType') || ''
      querySiteTree({
        addrType: 1,
        st: targetSt,
      })
        .then((res) => {
          if (res && res.success && res.result) {
            const rawList = Array.isArray(res.result) ? res.result : (res.result.records || [])
            const map = {}
            const rex = /^[a-zA-Z]/
            const traverse = (items) => {
              if (!Array.isArray(items)) return
              for (const item of items) {
                const key = String(item.key == null ? (item.id == null ? '' : item.id) : item.key)
                const isSite = Boolean(key && !rex.test(key[0]))
                if (isSite) {
                  map[key] = item.title || item.name || item.label || key
                }
                if (item.children && Array.isArray(item.children)) {
                  traverse(item.children)
                }
              }
            }
            traverse(rawList)
            this.siteNameObj = Object.assign({}, this.siteNameObj, map)
            try {
              let existing = {}
              const raw = sessionStorage.getItem('siteNamesMap')
              if (raw) existing = JSON.parse(raw) || {}
              sessionStorage.setItem('siteNamesMap', JSON.stringify(Object.assign(existing, map)))
            } catch (e) {}

            if (this.factorCode && this.dataObj && this.dataObj[this.factorCode]) {
              this.changeCode()
            }
          }
        })
        .catch(() => {})

      // 兜底查询 /site/info（全部拉取 size: -1）
      querySiteList({ current: 1, size: -1 })
        .then((res) => {
          if (res && res.success && res.result && res.result.records) {
            const map = {}
            res.result.records.forEach((item) => {
              if (item.id && (item.name || item.title)) {
                map[String(item.id)] = item.name || item.title
              }
            })
            this.siteNameObj = Object.assign({}, map, this.siteNameObj)
            if (this.factorCode && this.dataObj && this.dataObj[this.factorCode]) {
              this.changeCode()
            }
          }
        })
        .catch(() => {})
    },
    // 因子
    factorCodeChange(e) {
      this.factorCode = e.target.value
      this.changeCode()
    },
    // 趋势数据
    querySewageQuotaList(reportType, id, state = true) {
      if (!this.$refs.chart1) return
      if (!this.startTime || !this.endTime) {
        return
      }
      if (!this.treeSt) {
        this.treeSt = window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType') || ''
      }
      if (this.treeSt) {
        this.url = '/online/st' + this.treeSt + '/chart'
      }
      if (!this.treeSt || !this.url) {
        this.$message.warning('请选择监测站点类型！')
        return
      }
      let that = this
      let params = {
        stime: this.startTime,
        etime: this.endTime,
        quantum: id || '',
        type: '7',
        dataType: reportType,
        scope: '5',
        column: 'data_time',
        order: 'asc',
      }
      let options = []
      getAction(this.url, params).then((res) => {
        if (res && res.success && res.result) {
          that.chartData.xData = []
          const records = res.result.records || []
          records.forEach((v) => {
            that.chartData.xData.push(v.dataTime)
          })
          const siteList = (window.sessionStorage.getItem('sites') || id || '').split(',').filter(Boolean)
          that.dataObj = {}
          const factors = (res.result.query && res.result.query.factors) || []
          if (records.length > 0 && factors.length > 0) {
            factors.forEach((ele) => {
              that.dataObj[ele.code] = {}
              siteList.forEach((item) => {
                that.dataObj[ele.code][item] = []
                records.forEach((v) => {
                  if (v.data && v.data[item] && v.data[item][ele.code] != null) {
                    that.dataObj[ele.code][item].push(v.data[item][ele.code])
                  } else {
                    that.dataObj[ele.code][item].push(0)
                  }
                })
              })
            })
          }
          that.typeOptions = []
          factors.forEach((v) => {
            options.push({
              label: v.alias || v.title,
              value: v.code,
              categoryName: v.categoryName
            })
            that.typeOptions.push({
              label: v.alias || v.title,
              unit: v.unitName || '',
              value: v.code
            })
          })

          if (that.typeOptions.length > 0) {
            const exists = that.typeOptions.some((item) => item.value === that.factorCode)
            if (!exists) {
              that.factorCode = that.typeOptions[0].value
            }
          } else {
            that.factorCode = ''
          }
          that.typeOptionsSource = JSON.parse(JSON.stringify(that.typeOptions))
          if (state && that.$parent && that.$parent.$parent && that.$parent.$parent.$refs && that.$parent.$parent.$refs.colControl) {
            this.$nextTick(() => {
              that.$parent.$parent.$refs.colControl.firstState = true
              that.$emit('factorOption', options)
            })
          }

          that.changeCode()
        }
      })
    },
    // 渲染对应因子数据
    changeCode() {
      this.chartData.seriesData = []
      this.chartData.legendData = []
      let selectedOptions = this.typeOptions.find((item) => item.value == this.factorCode)
      let unit = selectedOptions ? selectedOptions.unit : ''
      if (this.dataObj && this.dataObj[this.factorCode]) {
        for (const key in this.dataObj[this.factorCode]) {
          let siteName = this.siteNameObj[key]
          if (!siteName) {
            try {
              const raw = sessionStorage.getItem('siteNamesMap')
              if (raw) {
                const map = JSON.parse(raw)
                if (map && map[key]) {
                  siteName = map[key]
                  this.siteNameObj[key] = siteName
                }
              }
            } catch (e) {}
          }
          siteName = siteName || key
          this.chartData.legendData.push(siteName)
          this.chartData.seriesData.push({
            name: siteName,
            data: this.dataObj[this.factorCode][key] || [],
            unit,
            type: 'line',
          })
        }
      }
      if (this.$refs.chart1 && this.$refs.chart1.initLineChart) {
        this.$refs.chart1.initLineChart(this.chartData, '#000')
      }
    },
  },
  watch: {
    currentSiteIds() {
      this.syncSiteNamesFromStorage()
      var ids = this.getTreeCurrentIds()
      this.ids = ids[1] || ''
      if (!this.treeSt) {
        this.treeSt = window.localStorage.getItem('treeSt') || window.sessionStorage.getItem('siteType') || ''
      }
      if (this.treeSt) {
        this.url = '/online/st' + this.treeSt + '/chart'
      }
      if (ids[0] == 1 && this.url && this.ids) {
        const idArr = this.ids.split(',')
        const hasMissingName = idArr.some((id) => !this.siteNameObj[id])
        if (hasMissingName) {
          this.loadSiteNames()
        }
        this.querySewageQuotaList(this.reportType, this.ids)
      } else if (!this.ids) {
        this.chartData.seriesData = []
        this.chartData.legendData = []
        this.chartData.xData = []
        if (this.$refs.chart1 && this.$refs.chart1.initLineChart) {
          this.$refs.chart1.initLineChart(this.chartData, '#000')
        }
      }
    },
    initNum() {
      if (this.ids) {
        this.querySewageQuotaList(this.reportType, this.ids, false)
      }
    },
  },
}
</script>

<style scoped>
.factorCode>>>.ant-radio-wrapper {
  color: #000 !important;
}
</style>
